import { InlineEdit } from "@/components/InlineEdit";

/** The company name as the page's click-to-edit title. A blank name is refused. */
export function CompanyNameEdit({ value, onSave }: { value: string; onSave: (name: string) => Promise<unknown> }) {
  return (
    <InlineEdit
      label="Company name"
      value={value}
      onSave={(v) => { const t = v.trim(); if (!t) throw new Error("Name is required"); return onSave(t); }}
      displayClassName="cursor-pointer rounded px-1 -mx-1 hover:bg-primary/5 inline-flex items-center gap-1"
      inputClassName="w-full rounded border bg-background px-1 py-0.5 text-[22px] font-bold outline-none"
    />
  );
}
